let
  _ecourse,
  _alert,
  _segment,
  _startDate,
  _endDate;
/**
 * @ngdoc Service
 * @param EcourseFactory
 * @param TimerService
 * @param Alerts
 * @constructor
 * @param $rootScope
 * @param $timeout
 * @param $state
 * @return {{init: init}}
 * @param $q
 */
export default function LiveService(EcourseFactory, TimerService, Alerts, $rootScope, $timeout, $state, $q) {
  'ngInject';

  let _callbacks = {
    'liveStart': [],
    'liveEnd': []
  };
  let _alert;
  let _segment;
  let _ecourse;
  let _startDate;
  let _endDate;

  /**
   * @description Find the next live or currently live segment and set timers to show live alerts and call callbacks.
   * @param ecourseObj
   */
  function init(ecourseObj) {
    _ecourse = ecourseObj;
    _segment = EcourseFactory.findLiveSegment(_ecourse);
    if (_segment) {
      setDates();
      goLive();

    }
    else {
      _segment = EcourseFactory.nextLiveSegment(_ecourse);
      if (_segment) {
        setDates();
        TimerService.add(goLive, conditionStart);
      }
    }
  }

  function on(action, callback) {
    if (action in _callbacks) {
      _callbacks[action].push(callback);
    }
  }

  function runActions(action) {
    if (action in _callbacks) {
      _callbacks[action].map(function (callback) {
        callback();
      });
    }
  }

  function goLive() {
    runActions('liveStart');
    addLiveAlert();
    TimerService.add(endLive, conditionEnd);
  }

  function endLive() {
    runActions('liveEnd');
    removeLiveAlert();
    //Run init to start a counter for the next live course.
    init(_ecourse);
  }

  /**
   * @description Resolve promises based on events.
   * @param event
   * @param segment
   * @returns {*}
   */
  function eventPromise(event, segment) {
    let request = $q.defer();
    on(event, function () {
      if (_segment.id === segment.id) {
        request.resolve();
      }
    });
    return request.promise;
  }

  /**
   * @description When the segment is live.
   * @param segment
   * @returns {*}
   */
  function live(segment) {
    if (EcourseFactory.isLive(segment)) {
      return $q.resolve();
    }
    return eventPromise('liveStart', segment);
  }

  /**
   * @description When the ecourse goes from live to not live.
   * @param segment
   * @returns {*}
   */
  function notLive(segment) {
    return eventPromise('liveEnd', segment);
  }

  /**
   * @description Removes the live alert when the segment is no longer live.
   */
  function removeLiveAlert() {
    if (_alert) {
      Alerts.remove(_alert);
      _alert = undefined;
    }
  }

  /**
   * @description Shows a live alert when the segment has become live.
   */
  function addLiveAlert() {
    if (!_alert && !onLiveState($state.params.segment, _segment.slug)) {
      $timeout(()=> {
        _alert = Alerts.add({
          type: 'live',
          template: "app/shared/directives/alerts/liveAlert.html",
          data: {
            slug: _ecourse.slug,
            segment: _segment.slug,
            media: _segment.mediaContent[0].id
          }
        });
      }, 1000);
    }
  }

  function conditionStart() {
    return Date.now() >= _startDate;
  }

  function conditionEnd() {
    return Date.now() >= _endDate;
  }

  function setDates() {
    _startDate = new Date(_segment.streamingStartDate);
    _endDate = new Date(_segment.streamingEndDate);
  }

  function onLiveState(curSlug, liveSlug) {
    return curSlug === liveSlug;
  }

//Listen to the state change
  $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams) {
    //If we have alive segment, an alert being shown and if the current routes segment is the same as the live then...
    if (_segment && _alert && onLiveState(toParams.segment, _segment.slug)) {
      //Remove the alert, but don't mess with timers.
      Alerts.remove(_alert);
    }
  });

  return {
    init,
    live,
    notLive
  };
}



/** WEBPACK FOOTER **
 ** ./src/app/ecourse/liveService/live.service.js
 **/